import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBIesR9fel3zo4f8f2r_Db-JQVher_YHig",
  authDomain: "school-risingstars.firebaseapp.com",
  projectId: "school-risingstars",
  storageBucket: "school-risingstars.firebasestorage.app",
  messagingSenderId: "897468493925",
  appId: "1:897468493925:web:34725c6eb28f42161b168c",
  measurementId: "G-KZXJEKMVNT",
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;
const auth = getAuth(app);
const functions = getFunctions(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, analytics, auth, functions, db, storage };
